// extracted by mini-css-extract-plugin
export default {"fullscreen":"bjmhrKYI","desktop":"desktop","mobile":"mobile","image":"Y_V8f2HE","caption":"lyK1Eq2P","captionHidden":"iKmIbuIo","icon":"oDN2aijz"};